import React, { FC } from "react";
import { Color } from "@evergis/color";
import { useTranslation } from "react-i18next";

import { ColorPicker } from "../ColorPicker";
import { ClassificationColorContainer } from "../../styled";
import { useSymbolSettingsContext } from "../../../../modules/Style/context/styleSettingsContext";

interface ClassifyColorProps {
  color: string;
  disabled?: boolean;
  classifyAble?: boolean;
  onChange: (v: Color) => void;
  onClick: VoidFunction;
}

export const ClassifyColorInput: FC<ClassifyColorProps> = ({
  color,
  disabled,
  classifyAble = true,
  onChange,
  onClick,
}) => {
  const { t } = useTranslation("common");
  const { ableClassify } = useSymbolSettingsContext();

  return ableClassify ? (
    <ClassificationColorContainer ableClassify={classifyAble}>
      <ColorPicker
        value={color}
        onChange={onChange}
        kind={classifyAble ? "classification" : null}
        iconButtonProps={{ onClick }}
        zIndex={10}
        disabled={disabled}
        tooltipProps={{
          content: t("symbolEditor.classifyByAttribute"),
          children: null,
        }}
      />
    </ClassificationColorContainer>
  ) : (
    <ColorPicker value={color} onChange={onChange} zIndex={10} disabled={disabled} />
  );
};
